import { SxProps, Theme } from '@mui/material/styles';

export const dealerTransferDetailStyles = {
    infoRow: {
        px: 3,
        py: 2,
        display: 'grid',
        gridTemplateColumns: '200px 1fr',
        gap: 2,
        alignItems: 'start',
    } satisfies SxProps<Theme>,
    loading: {
        display: 'flex',
        justifyContent: 'center',
        mt: 8,
    } satisfies SxProps<Theme>,
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    } satisfies SxProps<Theme>,
    sectionPaper: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
    } satisfies SxProps<Theme>,
    sectionTitle: {
        px: 3,
        py: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
    } satisfies SxProps<Theme>,
    ownersGrid: {
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: 3,
    } satisfies SxProps<Theme>,
};
